import { useCallback } from 'react';
import { TOAST_DURATIONS } from '../constants/reactionScheme';

interface UseMoleculeTransferProps {
  reactantConfig: string;
  productConfig: string;
  setReactantConfig: (config: string) => void;
  setProductConfig: (config: string) => void;
  showToast: (message: string, duration?: number) => void;
}

export function useMoleculeTransfer({
  reactantConfig,
  productConfig,
  setReactantConfig,
  setProductConfig,
  showToast,
}: UseMoleculeTransferProps) {
  // Transfer reactant to product
  const transferReactantToProduct = useCallback(() => {
    setProductConfig(reactantConfig);
    showToast('Transferred reactant to product', TOAST_DURATIONS.SHORT);
  }, [reactantConfig, setProductConfig, showToast]);

  // Transfer product to reactant
  const transferProductToReactant = useCallback(() => {
    setReactantConfig(productConfig);
    showToast('Transferred product to reactant', TOAST_DURATIONS.SHORT);
  }, [productConfig, setReactantConfig, showToast]);

  return {
    transferReactantToProduct,
    transferProductToReactant,
  };
}